{
  "Id": "ID:",
  "IdPlaceholder": "[Assegnato automaticamente]",
  "NamePlaceholder": "Ambiente di gestione centrale",
  "BillingId": "ID di fatturazione:",
  "ParentCme": "Genitore ECM:",
  "DescriptionIsRequired": "La descrizione è necessaria.",
  "CMEDetails_ButtonHelpLabel": "Aiuto?",
  "CMEDetails_ButtonSubmitLabel": "OK",
  "CMEDetails_ButtonCancelLabel": "Annullamento",
  "CMEDetails_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "CMEDetails_PromptConfirm": "Sì",
  "CMEDetails_PromptCancel": "Annullamento",
  "CMEDetails_Description": "Descrizione:",
  "NAME": "CMEDetails",
  "CMEDetails_ProviderIDS": "ID provider SSO:",
  "CMEDetails_ProviderIDS_Help": "Lasciare vuoto se non si sta configurando Single-Sign On (SSO). L'ID del provider è stato fornito se si utilizza SSO.",
  "CMEDetails_ProviderIDS_Validation_NoMoreThan5": "Non sono consentiti più di 5 ID fornitore SSO.",
  "CMEDetails_ProviderIDS_Validation_IDsInvalid": "Assicurarsi che gli ID del fornitore siano solo lettere, numeri, trattini o trattini bassi, non siano più lunghi di 15 caratteri e siano in un elenco separato da virgole.",
  "CMEDetails_Disable_Akixi_Login": "Disabilita la funzionalità di login del nome utente:"
}